import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterVideoSubCategory'
})
export class FilterVideoSubCategoryPipe implements PipeTransform {

  transform(subCategories: any[], subCategoryId: number): any[] {
    return subCategories.filter(x => x.SubCategoryId == subCategoryId)[0].SubCategoryDescription;
  }

  
}
